import HeroSection from "./referrals/HeroSection";
import EmergencyBanner from "./referrals/EmergencyBanner";
import SourcesSection from "./referrals/SourcesSection";
import StepsSection from "./referrals/StepsSection";
import DocumentsSection from "./referrals/DocumentsSection";
import FounderQuoteSection from "./referrals/FounderQuoteSection";
import ReferralForm from "./referrals/ReferralForm";

export default function Referrals() {
    return (
        <div data-testid="referrals-page">
            <HeroSection />
            <EmergencyBanner />
            <SourcesSection />
            <StepsSection />
            <DocumentsSection />
            <FounderQuoteSection />
            <ReferralForm />
        </div>
    );
}
